/* ============================================================
   NUAGE & CIE — nuage.js
   Panier « 1 article par commande » : tout ajout vide le panier
   puis ajoute le nouvel article (remplacement assumé, avec toast).
   ============================================================ */
(function () {
  "use strict";

  var N = (window.NUAGE = window.NUAGE || {});

  /* ---------- Formatage des prix selon le format de la boutique ---------- */
  function money(cents) {
    var val = cents / 100;
    var isInt = Math.round(val) === val;
    var num = isInt
      ? String(Math.round(val))
      : val.toFixed(2).replace(".", ",");
    num = num.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    var fmt = N.moneyFormat || "{{amount}} €";
    return fmt.replace(/\{\{[^}]*\}\}/, num);
  }

  /* ---------- Toasts ---------- */
  var toastBox = document.getElementById("nuage-toasts");
  function toast(title, message) {
    if (!toastBox) return;
    var el = document.createElement("div");
    el.className = "toast";
    el.innerHTML =
      '<span class="toast__cloud"><svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M17.5 19a4.5 4.5 0 1 0-.42-8.98 6 6 0 0 0-11.7 1.62A3.5 3.5 0 0 0 6.5 19h11Z"/></svg></span>' +
      '<span class="toast__txt"><strong></strong><em></em></span>' +
      '<button type="button" class="toast__x" aria-label="Fermer">✕</button>';
    el.querySelector("strong").textContent = title;
    el.querySelector("em").textContent = message;
    el.querySelector(".toast__x").addEventListener("click", function () {
      el.remove();
    });
    toastBox.appendChild(el);
    setTimeout(function () {
      el.classList.add("is-out");
      setTimeout(function () { el.remove(); }, 350);
    }, 4600);
    while (toastBox.children.length > 3) toastBox.firstChild.remove();
  }
  N.toast = toast;

  /* ---------- Bandeau annonce rotatif ---------- */
  document.querySelectorAll("[data-annbar]").forEach(function (bar) {
    var dataEl = bar.querySelector("[data-annbar-data]");
    var msgEl = bar.querySelector("[data-annbar-msg]");
    if (!dataEl || !msgEl) return;
    try {
      var msgs = JSON.parse(dataEl.textContent).filter(function (m) { return m && m.length; });
      if (msgs.length < 2) return;
      var i = 0;
      setInterval(function () {
        msgEl.classList.add("is-swap");
        setTimeout(function () {
          i = (i + 1) % msgs.length;
          msgEl.textContent = msgs[i];
          msgEl.classList.remove("is-swap");
        }, 300);
      }, 4200);
    } catch (e) {}
  });

  /* ---------- Header : ombre au scroll + menu mobile ---------- */
  var header = document.querySelector("[data-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    var burger = header.querySelector("[data-menu-toggle]");
    var mobileNav = header.querySelector("[data-mobile-nav]");
    if (burger && mobileNav) {
      burger.addEventListener("click", function () {
        mobileNav.hidden = !mobileNav.hidden;
      });
      mobileNav.querySelectorAll("a").forEach(function (a) {
        a.addEventListener("click", function () { mobileNav.hidden = true; });
      });
    }
  }

  /* ---------- Filtres du catalogue ---------- */
  var filterWrap = document.querySelector("[data-filters]");
  if (filterWrap) {
    var buttons = filterWrap.querySelectorAll("[data-filter]");
    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        buttons.forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        var f = btn.getAttribute("data-filter");
        document.querySelectorAll("[data-grid] .pcard").forEach(function (card) {
          var cats = card.getAttribute("data-cats") || "";
          card.classList.toggle("is-hidden", f !== "tous" && cats.indexOf("cat-" + f) === -1);
        });
      });
    });
  }

  /* ---------- Drawer panier ---------- */
  var drawer = document.getElementById("nuage-drawer");
  var overlay = document.getElementById("nuage-drawer-overlay");
  var drawerBody = document.getElementById("drawer-body");
  var drawerTotal = document.getElementById("drawer-total");

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    var bubble = document.querySelector("[data-cart-bubble]");
    if (bubble) bubble.hidden = cart.item_count === 0;

    if (drawerTotal) drawerTotal.textContent = money(cart.total_price);

    if (!drawerBody) return;
    if (cart.item_count === 0) {
      drawerBody.innerHTML =
        '<div class="drawer__empty">' +
        '<svg class="cloud cloud--xl" viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 19a4.5 4.5 0 1 0-.42-8.98 6 6 0 0 0-11.7 1.62A3.5 3.5 0 0 0 6.5 19h11Z"/></svg>' +
        "<p>Votre panier est vide… et vos pieds attendent leur nuage.</p>" +
        '<a class="btn btn--dark" href="/#modeles" data-drawer-close>Voir les 15 modèles</a></div>';
      return;
    }

    var html = "";
    cart.items.forEach(function (item, idx) {
      var compare = item.original_price > item.final_price ? "<s>" + money(item.original_price) + "</s>" : "";
      var variant = item.variant_title && item.variant_title !== "Default Title" ? "<p class='drawer-item__variant'>" + item.variant_title + "</p>" : "";
      var img = item.image
        ? '<img src="' + item.image + '" alt="" width="96" height="128" loading="lazy">'
        : "";
      html +=
        '<div class="drawer-item">' + img +
        '<div class="drawer-item__info"><h3>' + item.product_title + "</h3>" + variant +
        '<p class="drawer-item__price">' + compare + "<strong>" + money(item.final_price) + "</strong></p></div>" +
        '<button type="button" class="icon-btn drawer-item__remove" data-remove-line="' + (idx + 1) + '" aria-label="Retirer">✕</button></div>';
    });
    html +=
      '<div class="drawer__note"><svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M17.5 19a4.5 4.5 0 1 0-.42-8.98 6 6 0 0 0-11.7 1.62A3.5 3.5 0 0 0 6.5 19h11Z"/></svg>' +
      "Offre exclusive : votre panier n'accueille qu'un seul article (par commande et par adresse). Ajouter un autre modèle remplacera celui-ci.</div>" +
      '<p class="drawer__ship">Livraison offerte — expédiée sous 24 h</p>';
    drawerBody.innerHTML = html;
  }

  function openDrawer() {
    getCart().then(function (cart) {
      renderCart(cart);
      overlay.hidden = false;
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add("is-open");
        overlay.classList.add("is-open");
      });
      document.body.classList.add("no-scroll");
    });
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    document.body.classList.remove("no-scroll");
    setTimeout(function () {
      drawer.hidden = true;
      overlay.hidden = true;
    }, 400);
  }

  /* ---------- Ajout au panier : règle « 1 article » ---------- */
  function addOne(variantId, btn) {
    btn.disabled = true;
    getCart()
      .then(function (cart) {
        var hadItem = cart.item_count > 0;
        return fetch("/cart/clear.js", { method: "POST", credentials: "same-origin" })
          .then(function () {
            return fetch("/cart/add.js", {
              method: "POST",
              credentials: "same-origin",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: Number(variantId), quantity: 1 })
            });
          })
          .then(function (r) {
            if (!r.ok) throw new Error("add failed");
            return r.json();
          })
          .then(function (item) {
            if (hadItem) {
              toast("Offre exclusive", N.replacedMsg || "On a remplacé l'article — 1 seul nuage par commande !");
            } else {
              toast("Dans le panier !", (item.product_title || "Votre modèle") + " " + (N.addedMsg || "rejoint votre cocon."));
            }
            openDrawer();
          });
      })
      .catch(function () {
        toast("Oups", "Cette taille vient de partir — essayez une autre pointure.");
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  /* ---------- Délégation d'événements ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target;

    var open = t.closest("[data-cart-open]");
    if (open) { e.preventDefault(); openDrawer(); return; }

    if (t.closest("[data-drawer-close]")) { closeDrawer(); return; }
    if (t === overlay) { closeDrawer(); return; }

    var checkout = t.closest("[data-checkout]");
    if (checkout) { window.location.href = "/checkout"; return; }

    var remove = t.closest("[data-remove-line]");
    if (remove) {
      fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: Number(remove.getAttribute("data-remove-line")), quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart);
      return;
    }

    var add = t.closest("[data-add]");
    if (add) {
      e.preventDefault();
      var variantId = add.getAttribute("data-variant-id");
      if (!variantId) {
        var scope = add.closest("article, section, .pdp") || document;
        var select = scope.querySelector("[data-variant-select]");
        variantId = select ? select.value : null;
      }
      if (variantId) addOne(variantId, add);
      return;
    }

    var demo = t.closest("[data-demo-add]");
    if (demo) {
      toast("Catalogue de démonstration", "Ajoutez vos produits UGG dans Shopify : ils apparaîtront ici automatiquement, avec ce même design.");
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer && !drawer.hidden) closeDrawer();
  });
})();
